import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ManifestApiResponse } from '@manifest-cyber/types/interface/apiResponse';
import { PolicyFormData } from './useAiPolicies';
import { useNotifications } from '../../../../hooks/utils/useNotifications';
import { AxiosProxy } from '../../../../api/axiosProxy/axiosProxy';

type UpdateAiPoliciesResponse = ManifestApiResponse<PolicyFormData>;

export const useUpdateAiPolicies = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { success: showSuccessNotification, error: showErrorNotification } =
    useNotifications();

  return useMutation<UpdateAiPoliciesResponse, Error, PolicyFormData>({
    mutationFn: async (policyData: PolicyFormData): Promise<UpdateAiPoliciesResponse> => {
      // Commented out API call - replace with mock for testing
      const response = await AxiosProxy.put({
        url: 'policies/ai',
        body: policyData,
      });
      return response;
      // console.info('Mocking API call for updating AI policies', policyData);
      // return new Promise((resolve) => {
      //   setTimeout(() => {
      //     resolve(mockUpdateAiPoliciesResponse(policyData));
      //   }, 1000);
      // });
    },
    onSuccess: (data) => {
      if (data.success) {
        showSuccessNotification({
          title: t('page.aiPolicies.notifications.saveSuccess.title'),
        });

        queryClient.invalidateQueries(['ai-policies']);
      } else {
        showErrorNotification({
          title: t('page.aiPolicies.notifications.saveError.title'),
        });
      }
    },
    onError: (error) => {
      showErrorNotification({
        title: t('page.aiPolicies.notifications.saveError.title'),
      });
    },
  });
};
